// Generated from preview/worker/preorder-core.mjs.
(() => {
'use strict';
// Shared by the staged Worker and generated storefront asset.
const STORE_TIME_ZONE = "America/Chicago";
const SHIPPING_COPY = "Ships when stock arrives (see expected date above). Orders with multiple items ship when all are in stock. For faster delivery, consider ordering separately.";
const START = "<!-- PREORDER BLOCK START -->";
const END = "<!-- PREORDER BLOCK END -->";

function storeDay(now = new Date(), timeZone = STORE_TIME_ZONE) {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now);
  const get = type => parts.find(part => part.type === type).value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

function parseDate(value, timeZone = STORE_TIME_ZONE) {
  if (value == null || String(value).trim() === "") return null;
  const text = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    const date = new Date(`${text}T12:00:00Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === text ? text : null;
  }
  const date = /^\d+$/.test(text)
    ? new Date(Number(text) * (text.length <= 10 ? 1000 : 1))
    : new Date(text);
  return Number.isNaN(date.getTime()) ? null : storeDay(date, timeZone);
}

function formatDate(day) {
  return day ? new Date(`${day}T12:00:00Z`).toLocaleDateString("en-US", { timeZone: "UTC", month: "long", day: "numeric", year: "numeric" }) : "";
}

function variantState(variant, today = storeDay(), timeZone = STORE_TIME_ZONE) {
  const releaseDay = parseDate(variant.releaseDate, timeZone);
  const restockDay = parseDate(variant.restockShipDate, timeZone);
  const announceDay = parseDate(variant.restockAnnounceDate, timeZone);
  if (variant.releaseDate && !releaseDay) throw new Error(`Invalid release date for variant ${variant.id}`);
  if (variant.restockShipDate && !restockDay) throw new Error(`Invalid restock ship date for variant ${variant.id}`);
  if (variant.restockAnnounceDate && !announceDay) throw new Error(`Invalid restock announce date for variant ${variant.id}`);
  const restockActive = variant.requiresShipping !== false && !!restockDay && restockDay > today && (!announceDay || announceDay <= today);
  const releaseActive = !!releaseDay && releaseDay > today;
  const isPreorder = restockActive || releaseActive;
  const shipDay = restockActive ? restockDay : releaseActive ? releaseDay : null;
  return { ...variant, releaseDay, restockDay, announceDay, restockActive, isPreorder, shipDay, shipDate: formatDate(shipDay), releaseFormatted: formatDate(releaseDay), announceFormatted: formatDate(announceDay) };
}

function escapeHtml(text) {
  return String(text).replace(/[&<>"']/g, char => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));
}

function noticeHtml(state, includeShipping = true) {
  if (!state.isPreorder) return "";
  const date = escapeHtml(state.shipDate);
  let notice;
  if (state.restockActive) {
    const cutoff = state.announceDay ? ` If you place your order ${escapeHtml(state.announceFormatted)} or later, your expected ship date is <em>${date}.</em>` : "";
    notice = `<p><strong>This is a PRE-ORDER. Expected to ship the week of ${date}. The initial pressing of this product is SOLD OUT. A 2nd pressing is underway with an expected ship date of <em>${date}.</em>${cutoff}</strong></p>`;
  } else if (state.requiresShipping === false) {
    notice = `<p><strong>This is a PRE-ORDER. Delivers at midnight EST on ${date}.</strong></p>`;
  } else {
    notice = `<p><strong>This is a PRE-ORDER. Expected to ship the week of ${date}.</strong></p>`;
  }
  if (includeShipping && state.requiresShipping !== false) notice += `\n<p>${SHIPPING_COPY}</p>`;
  return notice;
}

function stripKnownParagraphs(html) {
  return html.replace(/<p\b[^>]*>([\s\S]*?)<\/p\s*>\s*/gi, (paragraph, inside) => {
    const text = inside.replace(/<[^>]*>/g, " ").replace(/&nbsp;|\u00a0/g, " ").replace(/\s+/g, " ").trim();
    if (/^This (?:product )?is a PRE-ORDER\. (?:Expected to ship|Delivers at midnight EST on)/i.test(text)) return "";
    if (/^The initial pressing of this product is SOLD OUT\. A 2nd pressing is underway with an expected ship date of /i.test(text)) return "";
    if (text.replace(/^PRE-ORDER ITEM!\s*/i, "") === SHIPPING_COPY) return "";
    return paragraph;
  });
}

function stripManagedNotices(current = "") {
  let html = current.replace(/<div\b[^>]*data-concord-preorder-notice=["']true["'][^>]*>[\s\S]*?<\/div>\s*/gi, "");
  html = html.replace(/<p[^>]*>\s*(<!--\s*PREORDER BLOCK (?:START|END)\s*-->)\s*<\/p>\s*/gi, "$1\n");
  html = html.replace(/<!--\s*PREORDER BLOCK START\s*-->([\s\S]*?)<!--\s*PREORDER BLOCK END\s*-->\s*/gi, (_, inner) => {
    return stripKnownParagraphs(inner)
      .replace(/^\s*<div\b[^>]*data-preorder-injected=["']true["'][^>]*>\s*/i, "")
      .replace(/\s*<\/div>\s*$/i, "").trim();
  });
  html = html.replace(/<div\b[^>]*data-preorder-injected=["']true["'][^>]*>([\s\S]*?)<\/div>\s*/gi, (_, inner) => stripKnownParagraphs(inner));
  return stripKnownParagraphs(html).trim();
}

function productHtml(product, states) {
  const base = stripManagedNotices(product.descriptionHtml || "");
  const active = states.filter(state => state.isPreorder);
  if (!active.length) return base;
  const signature = state => [state.restockActive, state.shipDay, state.announceDay, state.requiresShipping].join("|");
  const same = active.length === states.length && active.every(state => signature(state) === signature(active[0]));
  let notice = same ? noticeHtml(active[0]) : active.map(state => `<p><strong>${escapeHtml(state.title || "Variant")}:</strong></p>\n${noticeHtml(state, false)}`).join("\n");
  if (!same && active.some(state => state.requiresShipping !== false)) notice += `\n<p>${SHIPPING_COPY}</p>`;
  const block = `${START}\n<div data-preorder-injected="true" data-concord-preorder-notice="true">\n${notice}\n</div>\n${END}`;
  return base ? `${block}\n\n${base}` : block;
}

window.ConcordPreorderCore = { STORE_TIME_ZONE, SHIPPING_COPY, START, END, storeDay, parseDate, formatDate, variantState, escapeHtml, noticeHtml, stripManagedNotices, productHtml };
})();
